"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var message_panel_style_1 = require("../../../../theming/pricing-system/message-panel.style");

var theme_pricing_system_1 = require("../../../../theming/theme.pricing-system");

var static_text_1 = require("../../text/static-text/static-text");

var panel_1 = require("../panel/panel");

var MessagePanel = function (_super) {
  __extends(MessagePanel, _super);

  function MessagePanel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      fadeValue: new react_native_1.Animated.Value(1)
    };
    return _this;
  }

  MessagePanel.prototype.componentDidMount = function () {
    if (!this.props.content || !this.props.isFading) {
      return;
    }

    react_native_1.Animated.timing(this.state.fadeValue, {
      delay: message_panel_style_1.messagePanelFadeDelay,
      duration: message_panel_style_1.messagePanelFadeDuration,
      toValue: 0
    }).start(this.props.onFaded);
  };

  MessagePanel.prototype.render = function () {
    if (!this.props.content) {
      return null;
    }

    return react_1.default.createElement(react_native_1.Animated.View, {
      style: {
        opacity: this.state.fadeValue
      }
    }, react_1.default.createElement(panel_1.Panel, {
      headingTextStyle: [theme_pricing_system_1.pricingStyles.messagePanelHeadingTextStyle, this.props.headingTextStyle],
      viewStyle: [this.panelViewStyle, this.props.viewStyle],
      heading: this.props.heading,
      level: this.props.level
    }, this.renderContent()));
  };

  MessagePanel.prototype.renderContent = function () {
    var content = this.props.content;
    return typeof content === 'string' ? react_1.default.createElement(static_text_1.StaticText, {
      text: content,
      textStyle: this.contentTextStyle
    }) : content;
  };

  Object.defineProperty(MessagePanel.prototype, "panelViewStyle", {
    get: function get() {
      var viewStyle = this.props.type === 'success' ? theme_pricing_system_1.pricingStyles.messagePanelSuccessViewStyle : theme_pricing_system_1.pricingStyles.messagePanelInfoViewStyle;
      return this.props.hasShadow ? [viewStyle, theme_pricing_system_1.pricingStyles.messagePanelShadowAddViewStyle] : viewStyle;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(MessagePanel.prototype, "contentTextStyle", {
    get: function get() {
      return this.props.type === 'success' ? theme_pricing_system_1.pricingStyles.messagePanelSuccessTextStyle : theme_pricing_system_1.pricingStyles.messagePanelInfoTextStyle;
    },
    enumerable: true,
    configurable: true
  });
  return MessagePanel;
}(react_1.default.Component);

exports.MessagePanel = MessagePanel;